import { Dependency } from "index";
import { PureComponent } from "react";

export default abstract class DependencyBase<Type> extends PureComponent {
    public static dependency = () => this._componentDependencies.every((dependency) => dependency());
    public static onScriptLoaded = () => {};
    static _componentDependencies: Dependency[] = [];
    public dependency = () => {};
}
